import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDashboardMiddle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconDashboardMiddle"><Path d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 13.4319 21.699 14.7936 21.1569 16.0251C21.1075 16.0088 21.0548 16 21 16H12.5V8.5C12.5 8.22386 12.2761 8 12 8C11.7239 8 11.5 8.22386 11.5 8.5V16H3C2.94519 16 2.89245 16.0088 2.8431 16.0251C2.30097 14.7936 2 13.4319 2 12Z" fill="currentColor"/><Path d="M3.33594 17C5.06498 19.989 8.2967 22 11.9981 22C15.6995 22 18.9312 19.989 20.6603 17H3.33594Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDashboardMiddle;
